/**
 * Strict capability gate for an internal menu/permission id (e.g. 'share-links').
 *
 * Unlike `AuthContext.canAccessMenu`, this does NOT fail open on an empty/unhydrated `allowedMenuIds`:
 * a non-admin is granted the capability ONLY when it is explicitly present in `allowedMenuIds`. That
 * makes it the correct gate for an admin-revokable internal capability — it honors an admin un-ticking
 * the permission in the matrix (the id drops out of `allowedMenuIds`) and never advertises the action to
 * a role that was never granted it (e.g. Finance/ClientManager) or to a user whose menu ids haven't
 * loaded yet. Admins always pass (mirrors the server-side MenuPermissionService admin bypass).
 *
 * Server-side enforcement (the `share-links` authorization policy) remains the security boundary; this is
 * purely the client-side show/hide gate kept consistent with it.
 */
export function hasMenuCapability(
  menuId: string,
  opts: { isAdmin: boolean; isSuperAdmin: boolean; allowedMenuIds?: string[] | null },
): boolean {
  if (opts.isSuperAdmin || opts.isAdmin) return true;
  return opts.allowedMenuIds?.includes(menuId) ?? false;
}
